import React from "react";
import ProfileForm from "../Components/Forms/ProfileForm";

const ProfilePage: React.FC = () => {
  return <ProfileForm />;
};

export default ProfilePage;
